import { Avatar, LinkButton, ModalWindow, UIHeading2, UIHeading4, UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './ContactsModal.css';

interface IContactsModalProps {
  name: string;
  logo: string;
  phone: string;
  open: boolean;
  onClose(): void;
  onCallClick?(): void;
}

export const ContactsModal: React.FC<IContactsModalProps> = ({ name, logo, phone, open, onClose, onCallClick }) => {
  return (
    <ModalWindow open={open} onClose={onClose}>
      <div data-name="ContactsModal" className={styles['content']}>
        <UIHeading2>Контакты</UIHeading2>
        <div className={styles['builder']}>
          <Avatar size={48} type="builder" src={logo} target="_blank" />
          <div className={styles['name']}>
            <UIText1>{name}</UIText1>
            <UIText1 color="text-secondary-default">Строительная компания</UIText1>
          </div>
        </div>
        <div className={styles['footer']}>
          <UIHeading4>{phone}</UIHeading4>
          <LinkButton data-name="ContactsModalCallButton" href={`tel:${phone}`} onClick={onCallClick}>
            Позвонить
          </LinkButton>
        </div>
      </div>
    </ModalWindow>
  );
};
